import { ADD_ACTIVITIES } from './types';

export const addActivities = data => ({
  type: ADD_ACTIVITIES,
  data
});